import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IDropdownResponse,
  IDocumentFileVersion,
  IFileManagementDocument
} from '../models';

const baseUrl = '/api/documentation-file-management';

export const getDocumentationFiles = async (): Promise<IFileManagementDocument[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}`);
    return data;
  } catch (error: any) {
    logError(error, 'getDocumentationFiles failed');
    return Promise.reject(error.response.data);
  }
};

export const getDocumentationFile = async (
  documentId: number | string,
): Promise<any> => {
  try {
    const data = await axios.get(`${baseUrl}/${documentId}`, {
      responseType: 'blob',
    });
    return data;
  } catch (error: any) {
    logError(error, 'getDocumentationFile failed');
    return Promise.reject(error.response.data);
  }
};

export const getDocumentFileVersions = async (
  documentId: number | string
): Promise<IDocumentFileVersion[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${documentId}/versions`);
    return data;
  } catch (error) {
    logError(error, 'getDocumentFileVersions failed');
    return Promise.reject(error);
  }
};

export const downloadDocumentFileVersion = async (
  documentId: number | string,
  documentVersionId: number | string
): Promise<any> => {
  try {
    const data = await axios.get(
      `${baseUrl}/${documentId}/versions/${documentVersionId}`,
      {
        responseType: 'blob'
      }
    );
    return data;
  } catch (error) {
    logError(error, 'downloadDocumentFileVersion failed');
    return Promise.reject(error);
  }
};

export const replaceDocumentationFile = async (
  documentId: number | string,
  document: any
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${documentId}`, document);
    return data;
  } catch (error: any) {
    logError(
      { error, payload: { documentId, document } },
      'replaceDocumentationFile failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getUploadDocumentTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/upload-document-types`
    );

    return data;
  } catch (error: any) {
    logError(error, 'getUploadDocumentTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const uploadFileManagementDocument = async (
  documentTypeId: number | string,
  fileData: any
): Promise<any> => {
  try {
    const { data } = await axios.post(`${baseUrl}/${documentTypeId}`, fileData);
    return data;
  } catch (error: any) {
    logError({ error, payload: { documentTypeId, fileData } }, 'uploadFileManagementDocument failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteFileManagementDocument = async (documentId: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${documentId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteFileManagementDocument failed');
    return error.response.data;
  }
};